{
  "name": "@staysignals/sdk-web",
  "version": "0.1.2",
  "private": true,
  "description": "Browser SDK (script-tag) that collects device signals and posts them to StaySignals /v1/collect. Deployed as a single IIFE to cdn.staysignals.com.",
  "scripts": {
    "build": "tsup",
    "postbuild": "node scripts/pin-release.mjs",
    "dev": "tsup --watch",
    "serve": "pnpm run serve:checkout",
    "serve:checkout": "node scripts/serve-checkout.mjs",
    "serve:checkout:prod": "SDK_CHECKOUT_API_BASE_URL=https://api.staysignals.com node scripts/serve-checkout.mjs",
    "test": "vitest run",
    "test:watch": "vitest",
    "lint": "eslint \"{src,test}/**/*.ts\" --fix",
    "typecheck": "tsc --noEmit"
  },
  "dependencies": {
    "@fingerprintjs/fingerprintjs": "^4.4.4"
  },
  "devDependencies": {
    "@eslint/js": "^9.18.0",
    "@types/node": "^20.14.10",
    "eslint": "^9.18.0",
    "globals": "^17.0.0",
    "jsdom": "^25.0.1",
    "sirv-cli": "^3.0.0",
    "tsup": "^8.3.5",
    "typescript": "^5.6.3",
    "typescript-eslint": "^8.20.0",
    "vitest": "^4.1.5"
  }
}
